import "./index.css";
import { useMoviesStore } from "../../stores/useMoviesStore";
import { useEffect, useRef, useCallback } from "react";
import { MovieItem } from "../../components/movie-item";
import { NoItemsFound } from "../../components/common/NoItemsFound";
import Loader from "../../components/common/Loader";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";

const UpcomingScreen = () => {
  const { upcomingMovies, fetchUpcomingMovies, hasUpComingMovies, isLoading } =
    useMoviesStore();

  const pageRef = useRef<number>(1);

  const fetchUpcoming = useCallback(() => {
    fetchUpcomingMovies({
      page: pageRef.current,
    });
  }, [fetchUpcomingMovies]);

  const loadMoreVideos = useCallback(() => {
    pageRef.current = pageRef.current + 1;
    fetchUpcoming();
  }, [fetchUpcoming]);

  useEffect(() => {
    pageRef.current = 1;
    fetchUpcoming();
  }, [fetchUpcoming]);

  const { lastElementRef } = useInfiniteScroll({
    isLoading,
    hasNextPage: hasUpComingMovies,
    onLoadMore: loadMoreVideos,
  });

  return (
    <div className="screen-container">
      {isLoading && upcomingMovies.length === 0 ? (
        <Loader />
      ) : upcomingMovies.length === 0 ? (
        <NoItemsFound text="No upcoming movies!" />
      ) : (
        <>
          <div className="grid-container">
            {upcomingMovies.map((item) => (
              <MovieItem key={item.id} movie={item} />
            ))}
          </div>
          {hasUpComingMovies && (
            <div ref={lastElementRef} style={{ height: "20px" }} />
          )}
        </>
      )}
      {isLoading && upcomingMovies.length > 0 && <Loader />}
    </div>
  );
};

export default UpcomingScreen;
